import { MAP_TYPES } from '@deck.gl/carto';

const TRANSIT_STOP_SOURCE_ID = 'transitStopSource';

const source = {
  id: TRANSIT_STOP_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: `transit_stop_source`,
};
 
export default source;